import './index.scss';

import React from 'react';
import App from './App';
import { configureAmplify } from './config/amplify';
import reportWebVitals from './reportWebVitals';

import { createRoot } from 'react-dom/client';

// Configure Amplify
configureAmplify();

const container = document.getElementById('root');

// @note should never be null
if (container) {
  const root = createRoot(container);
  root.render(
    // <React.StrictMode>
     <App />
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
